import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';

class IntentionService extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/chatbot-server/api'
  };
  // 获取全部意图列表
  getAllList(data: any) {
    return this.get('/intents/all', data);
  }
  // 获取意图列表
  getList(data: any) {
    return this.get('/intents', data);
  }
  // 意图新增
  addIntention(data: any) {
    return this.post('/intents', data);
  }
  // 意图新增
  editIntention(intent_id: any, data: any) {
    return this.put(`/intents/${intent_id}`, data);
  }
  // 删除意图
  deleteIntention(intent_id: any) {
    return this.delete(`/intents/${intent_id}`);
  }
  // 测试意图
  testIntention(intent_id: any, data: string) {
    return this.post(`intents/test/${intent_id}`, data);
  }
  // 复制意图
  copyIntention(intent_id: any, data: any) {
    return this.post(`/intents/copy/${intent_id}`, data);
  }
  // 根据意图id 获取用户话术列表
  getIntentionInput(intent_id: any) {
    return this.get(`/intents/corpus/${intent_id}`);
  }
  // 更新用户话术
  updateIntentionInput(intent_id: any, data: any) {
    return this.put(`/intents/corpus/${intent_id}`, data);
  }
  // 获取pipeline列表
  getPipelines() {
    return this.get(`/intents/pipeline`);
  }
  // 导入语料
  upload(file: any) {
    return this.post(`/intents/corpus/upload`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  // 下载意图语料
  exportFile(ids: any) {
    return this.post('/intents/export', ids, {
      responseType: 'blob'
    });
  }
}
export default new IntentionService();
